import CommonTitleBar from "components/common/CommonTitleBar";
import ExpandableText from "components/common/ExpandableText";
import Filters from "components/common/Filters";
import NoDataFound from "components/common/NoDataFound";
import Paginations from "components/common/Paginations";
import Spinners from "components/common/Spinners";
import { formatBookingDateAndTime, formatDate, getRelativeTimeFromNow, setPageTitle } from "components/common/Utils";
import { spaceTypeOptions } from "components/constants/DropdownOptions";
import TableShimmer from "components/ShimmerEffects/CommonShimmer/TableShimmer";
import React, { useEffect, useState } from "react";
import { Badge, Col, Container, Row, Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getWebsiteRequests } from "store/actions/workspaceSlice";

const WebsiteRequests = () => {
  const { t } = useTranslation();
  setPageTitle("Website Requests", t);


  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [keyword, setKeyword] = useState("");

  const {
    loading,
    perPage,
    totalCount,
    totalPages,
    currentPage,
    websiteRequests,
  } = useSelector((state) => state.Workspace);

  useEffect(() => {
    getAllData();
  }, []);

  const getAllData = (page, action) => {
    const { actionType } = action || {}; // SEARCH, RESET, RESET_KEYWORD
    const isReset = actionType === "RESET";

    const payload = {
      perPage,
      pageNo: page || 1,
      orderBy: -1,
      keyword: ["RESET", "RESET_KEYWORD"].includes(actionType)
        ? ""
        : keyword || "",
    };

    dispatch(getWebsiteRequests(payload));
  };

  const handleReset = () => {
    setKeyword("");
    getAllData(1, { actionType: "RESET" });
  };

  return (
    <React.Fragment>
      <div className="page-content common_page">
        <Container fluid>
          <CommonTitleBar title={t("Website Requests")} />
          <div className="common_wrapper">
            <Filters
              keyword={keyword}
              setKeyword={setKeyword}
              isDateRange={false}
              onSearch={getAllData}
              onReset={handleReset}
            />
            <Row>
              <Col lg={12}>
                {loading ? (
                  <TableShimmer col={8} />
                ) : websiteRequests.length === 0 ? (
                  <NoDataFound />
                ) : (
                  <div className="common_table_style">
                    <Table>
                      <thead className="t_head">
                        <tr>
                          <th>{t("#")}</th>
                          <th>{t("Submission Date")}</th>
                          <th>{t("Customer Name")}</th>
                          <th>{t("Customer Phone")}</th>
                          <th>{t("Has Booking For Company")}</th>
                          <th>{t("Space Type")}</th>
                          <th>{t("Branches")}</th>
                          <th>{t("Date & Time")}</th>
                          <th>{t("Message")}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {websiteRequests?.map((item, index) => (
                          <tr key={item?._id}>
                            <td>{index + 1}</td>
                            <td>
                              <p className="w_fit_content">
                                {getRelativeTimeFromNow(item?.createdAt)}
                              </p>
                            </td>
                            <td>{item.name}</td>
                            <td>{item.phone}</td>
                            <td>
                              <Badge
                                bg={
                                  item.hasBookingForCompany
                                    ? " bg_primary"
                                    : " bg-secondary"
                                }
                              >
                                {item.hasBookingForCompany ? t("Yes") : t("No")}
                              </Badge>
                            </td>
                            <td>
                              {item?.spaceTypes
                                ?.map(
                                  (type) =>
                                    spaceTypeOptions.find(
                                      (option) => option.value === type
                                    )?.name
                                )
                                .filter(Boolean)
                                .join(", ")}
                            </td>
                            <td>
                              <div style={{ minWidth: 150 }}>
                                <ExpandableText
                                  text={item?.branches
                                    ?.map((b) => b.name)
                                    .join(", ")}
                                  maxLines={2}
                                />
                              </div>
                            </td>
                            <td>
                              <p className="w_fit_content">
                                {formatBookingDateAndTime(item?.bookingDate)}
                              </p>
                            </td>
                            <td>
                              <div style={{ minWidth: 300 }}>
                                <ExpandableText
                                  text={item?.message}
                                  maxLines={2}
                                />
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                )}
              </Col>
            </Row>
          </div>
          {!loading && (
            <Paginations
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={(page) => {
                getAllData(page);
              }}
              totalCount={totalCount}
            />
          )}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default WebsiteRequests;
